export default __webpack_public_path__ + "static/media/int.8859f6a1.png";